import { useCallback, useContext } from 'react';
import _ from 'underscore';
import { useLocalizeBudget } from '@bingads-webui-campaign-react/wizard-shared-components';
import { usePreference, preferenceNames } from '@bingads-webui-campaign-react/pmax-lite-data';
import { I18nContext } from '@bingads-webui-react/i18n-context';

export const roasMtToUI = roas => (_.isNumber(roas) ? roas * 100 : null);
export const roasUiToMt = roas => (_.isNumber(roas) ? (roas / 100).toFixed(4) : null);

export const useBudgetModel = () => {
  const i18n = useContext(I18nContext);
  const { localizeBudget } = useLocalizeBudget();
  const [{ value: currencyPreference }] = usePreference(preferenceNames.SelectedCurrency);

  const budgetModelToViewModel = useCallback((campaign) => {
    const budgetAmount = _.get(campaign, ['Budget', 'Amount']);
    const bidStrategy = _.get(campaign, ['BiddingScheme', 'Type']);
    const bidValueCpc = _.get(campaign, ['BiddingScheme', 'ManualCPC']) || null;
    const bidValueCpi = _.get(campaign, ['BiddingScheme', 'ManualCPI']) || null;
    const cpa = _.get(campaign, ['BiddingScheme', 'TargetCpa']);
    const roas = parseFloat(_.get(campaign, ['BiddingScheme', 'TargetRoas'])) || null;
    const isInitialAdditionalDetailsChecked = _.isNumber(cpa) || _.isNumber(roas) || _.isNumber(bidValueCpc) || _.isNumber(bidValueCpi);

    return {
      budgetAmount: localizeBudget(budgetAmount, 'USD'),
      bidStrategy,
      ManualCPI: bidValueCpi,
      ManualCPC: bidValueCpc,
      currency: currencyPreference,
      cpa,
      roas: roasMtToUI(roas),
      isInitialAdditionalDetailsChecked,
      isMarketingMetricValid: true,
    };
  }, [currencyPreference, localizeBudget]);

  const budgetViewModelToModel = useCallback((bidStrategy, budgetAmount, bidValueCpc = null, bidValueCpi = null) => (
    {
      BiddingScheme: {
        Type: bidStrategy,
        ...(bidStrategy === 'ManualCpc' && bidValueCpc !== null && { ManualCpc: bidValueCpc }),
        ...(bidStrategy === 'ManualCpa' && bidValueCpi !== null && { ManualCpi: bidValueCpi }),
      },
      Budget: {
        Amount: i18n.parseDecimal(budgetAmount),
        Type: 'DailyStandard',
      },
    }), [i18n]);

  const isBudgetInputValid = (isBudgetValid, isMarketingMetricValid) =>
    isBudgetValid && isMarketingMetricValid;

  return {
    budgetModelToViewModel,
    budgetViewModelToModel,
    isBudgetInputValid,
  };
};
